import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import ArchiveDetail from "@/pages/ArchiveDetail";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PaymentResult from "@/pages/PaymentResult";
import PackageDownload from "@/pages/PackageDownload";
import Portal from "@/pages/Portal";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-[color:var(--gt-text-2)]">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

export default function App() {
    return (
        <AuthProvider>
            <div className="App">
                <Toaster theme="dark" position="top-right" richColors />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/archive" element={<Archive />} />
                        <Route path="/archive/:id" element={<ArchiveDetail />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                        <Route path="/payment/success" element={<PaymentResult kind="success" />} />
                        <Route path="/payment/cancel" element={<PaymentResult kind="cancel" />} />
                        <Route path="/pkg/:token" element={<PackageDownload />} />
                        <Route path="/portal/:token" element={<Portal />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </AuthProvider>
    );
}
